// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/schedule',
    name: 'schedule',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/booking/schedule/Schedule.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'cotizador',
    },
  },
]

export default formTable
